import script from "./CalendarYear.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarYear.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarYear.vue?vue&type=style&index=0&id=c340e226&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c340e226"]])

export default __exports__